export default {
  company: "Company",
  share_holder: "Share Holder",
  super_senior: "Super Senior",
  senior: "Senior",
  master: "Master",
  agent: "Agent",
  member: "Member",

  account_id: "Username",
  action: "Action",
  available_credit: "Available Credit",
  active: "Active",
  account_balance: "Account Balance",
  agent_credit: "Agent Credit",
  authority: "Authority",
  account_information: "Account Information",
  account_list: "Account List",
  audit_by: "Audit By",
  add_account: "Add Account",
  add_sub_account: "Add Sub Account",
  authority_option: "Authority Options",
  account: "Account",
  access_log: "Access Log",
  account_log: "Account Log",
  account_details: "Account Details",
  action_by: "Action By",
  away_team_name: "Away Team Name",
  amount: "Amount",
  account_before_balance: "Account Before Balance",
  account_after_balance: "Account After Balance",
  active_bet_list: "Active Bet List",
  agent_win_all: "Agent Win All",
  agent_win_half: "Agent Win Half",
  agent_lose_all: "Agent Lose All",
  agent_lose_half: "Agent Lose Half",
  accumulate_win: "Accumulated Win",
  add_sub: "Add Sub-account",
  account_type: "Account Type",
  account_pt: "Account PT",
  account_min: "Account Min",
  away_score: "Away Score",
  add_secondary_full: "Add Secondary Account",
  accumulate_balance: "Accumulate Balance",
  away: "Away",
  aa: "HT: Away | FT: Away",
  ad: "HT: Away | FT: Draw",
  ah: "HT: Away | FT: Home",
  anb: "Away No Bet",
  all: "All",
  account_existed: "Account existed.",
  account_not_existed: "Account not existed.",
  account_status: "Account Status",
  account_block: "Account Block",
  account_unblock: "Account Unblock",
  add_secondary: "Add Secondary Account",
  agent_bulk: "Agent Bulk",

  balance: "Balance",
  bet: "Bet",
  block: "Block",
  blocked: "Blocked",
  back: "Back",
  bet_limit: "Bet Limit",
  basketball: "Basketball",
  baseball: "Baseball",
  bet_limit_log: "Bet Limit Log",
  browser_agent: "Browser Agent",
  bet_limit_packages: "Bet Limit Packages",
  ball: "Ball",
  bet_count: "Bet Count",
  bet_type: "Bet Type",
  bl: "Bet Limit",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "Bet List",
  bs: "Both To Score",
  basic: "Basic",

  credit: "Credit",
  cm: "Commission",
  close: "Close",
  cancel: "Cancel",
  continue: "Continue",
  created_on: "Created On",
  copy_and_create: "Copy And Create",
  copy: "Copy",
  confirm_password: "Confirm Password",
  confirm_security_code: "Confirm Security Code",
  contact_phone: "Phone",
  contact_email: "Email",
  cash_balance: "Cash Balance",
  currency: "Currency",
  credit_limit: "Credit Limit",
  credit_balance: "Credit/Balance",
  commission: "Commission",
  correct_score: "Correct Score",
  commission_log: "Commission Log",
  current_balance: "Current Balance",
  cancelled_bet_list: "Cancelled Bet List",
  category: "Category",
  copy_to_bottom: "Copy to Bottom",
  comm_sportsbook_hdp_a: "HDP A",
  comm_sportsbook_hdp_b: "HDP B",
  comm_sportsbook_hdp_c: "HDP C",
  comm_sportsbook_hdp_d: "HDP D",
  comm_sportsbook_hdp_e: "HDP E",
  comm_sportsbook_hdp_f: "HDP F",
  comm_sportsbook_hdp_g: "HDP G",
  comm_sportsbook_hdp_h: "HDP H",
  comm_sportsbook_hdp_i: "HDP I",
  comm_sportsbook_hdp_j: "HDP J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "Others",
  comm_sportsbook_hdp_packages: "HDP Packages",
  comm_slots: "Slots",
  comm_casino: "Live Casino",
  comm_lotto: "Lotto",
  comm_keno: "Keno",
  comm_cockfight: "Cockfight",
  comm_lottery_1d: "Lottery 1D",
  comm_lottery_2d: "Lottery 2D",
  comm_lottery_3d: "Lottery 3D",
  comm_lottery_4d: "Lottery 4D",
  completed: "Completed",
  clean_sheet: "Clean Sheet",
  cockfight: "Cockfight",
  cockfight_bet_limit_packages: "Cockfight Bet Limit Packages",
  close_room: "Close Room",
  close_bet: "Close Bet",
  create_room: "Create Room",
  match_selection: "Match Selection",
  selected_match: "Selected Match",
  insert: "Insert",
  active_reopen: "Active / Reopen",

  combine: {
    bet_limit_A: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_KRWA: "Limit A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "Limit B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "Limit C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "Limit D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "Limit E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "Limit F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "Limit G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CNYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_CNYD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_CNYE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_CNYF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_CNYG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_HKDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "Limit B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "Limit C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "Limit D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "Limit E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "Limit A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "Limit B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "Limit C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "Limit D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "Limit E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "Limit F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "Limit G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "Limit C (@:ui.min = 2 @:ui.max = 400)",
    bet_limit_USDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "Limit A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "Limit B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "Limit C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "Limit D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "Limit E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "Limit F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "Limit G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "Limit A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "Limit B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "Limit C (@:ui.min = 25 @:ui.max = 3,000)",
    bet_limit_IDRD: "Limit D (@:ui.min = 50 @:ui.max = 15,000)",
    bet_limit_IDRE: "Limit E (@:ui.min = 50 @:ui.max = 30,000)",
    bet_limit_IDRF: "Limit F (@:ui.min = 50 @:ui.max = 60,000)",
    bet_limit_IDRG: "Limit G (@:ui.min = 50 @:ui.max = 100,000)",

    comm_limit_A: "A (@:ui.hdp/@:ui.ou/@:ui.oe) 5%",
    comm_limit_B: "B (@:ui.hdp/@:ui.ou/@:ui.oe) 6%",
    comm_limit_C: "C (@:ui.hdp/@:ui.ou/@:ui.oe) 7%",
    comm_limit_D: "D (@:ui.hdp/@:ui.ou/@:ui.oe) 8%",
    comm_limit_E: "E (@:ui.hdp/@:ui.ou/@:ui.oe) 9%",
    comm_limit_F: "F (@:ui.hdp/@:ui.ou/@:ui.oe) 10%",
    comm_limit_G: "G (@:ui.hdp/@:ui.ou/@:ui.oe) 11%",
    comm_limit_H: "H (@:ui.hdp/@:ui.ou/@:ui.oe) 12%",
    comm_limit_I: "I (@:ui.hdp/@:ui.ou/@:ui.oe) 13%",
    comm_limit_J: "J (@:ui.hdp/@:ui.ou/@:ui.oe) 14%",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile",
    update_hdp_packages: "@:ui.update @:ui.hdp_packages",
  },

  downline_id: "Downline ID",
  disabled: "Disabled",
  downline: "Downline",
  dashboard: "Dashboard",
  downline_list: "Downline List",
  double_chance: "Double Chance",
  downline_credit: "Downline Credit",
  date: "Date",
  data: "Data",
  date_time: "Date/Time",
  date_range: "Date Range",
  details: "Details",
  draw: "Draw",
  daily_statement: "Statement",
  daily_statement_member: "Member Statement",
  daily_winlose: "Daily Win Lose",
  daily_winlose_simple: "Win Lose Simple",
  daily_winlose_details: "Win Lose",
  daily_reset: "Daily Reset",
  daily_winlose_platform: "Win Lose By Product",
  daily_winlose_match: "Win Lose By Match",
  detail: "Detail",
  downline_outstanding: "Downline Outstanding",
  dd: "HT: Draw | FT: Draw",
  dh: "HT: Draw | FT: Home",
  da: "HT: Draw | FT: Away",
  dnb: "Draw No Bet",
  draw_cancel: "Draw",
  default: "Default",

  edit: "Edit",
  enter_information: "Enter Information",
  enable: "Enable",
  esports: "E-Sports",
  edit_account: "Edit Account",
  edit_limit: "Edit Limit",
  early: "Early",
  event: "Event",
  enabled: "Enabled",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "Even",
  edited: "Edited",
  export_excel: "Export Excel",
  end: "End",
  entry_fee: "Entry Fee",
  entry_points: "Entry Points",

  from: "From",
  full: "Full",
  formula: "Formula",

  forecast: "Forecast",
  forecast_soccer: "Forecast (Soccer)",
  freeze: "Freeze",
  full_name: "Name",
  full_mode: "Full Mode",
  first_hdp: "1st Hdp",
  first_ou: "1st OU",
  fh: "FH",
  forecast_details: "Forecast Details",
  full_time: "Full Time",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "First Goal",
  first_half: "First Half",

  grand_total: "Grand Total",
  gross_commission: "Gross Commission",
  game_name: "Game Name",
  game_provider: "Game Provider",
  game_result: "Game Result",
  game_result_details: "Game Result Details",
  gross_winlose: "Gross Win Lose",
  game_type: "Game Type",

  ht: "HT",
  half: "Half",
  half_time: "Half Time",
  home: "Home",
  hdp: "HDP",
  hdp_packages: "HDP Packages",
  home_team_name: "Home Team Name",
  home_score: "Home Score",
  hh: "HT: Home | FT: Home",
  hd: "HT: Home | FT: Draw",
  ha: "HT: Home | FT: Away",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "Home No Bet",

  ip_address: "IP Address",
  id: "ID",

  jackpot: "Jackpot",

  key: "Key",
  keno: "Keno",
  keno_bet_limit_packages: "Keno Bet Limit Packages",

  log_id: "Log ID",
  lottery: "Lottery",
  lottery_1d: "Lottery 1D",
  lottery_2d: "Lottery 2D",
  lottery_3d: "Lottery 3D",
  lottery_4d: "Lottery 4D",
  lotto: "Lotto",
  log: "Log",
  list: "List",
  logs: "Logs",
  login: "Login",
  logout: "Logout",
  login_ip: "Login IP",
  login_id: "Login ID",
  last_name: "Last name",
  live_casino: "Live Casino",
  livecasino: "Live Casino",
  lastweek: "Last Week",
  lastmonth: "Last Month",
  last3month: "Last 3 Months",
  league_id: "League ID",
  league_name: "League Name",
  league: "League",
  livecasino_platform: "Livecasino Platform",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "Livecasino Bet Limit Packages",
  last_goal: "Last Goal",
  live: "Live",
  lose: "Lose",
  lose_half: "Lose Half",
  last_week: "Last Week",
  last_month: "Last Month",
  lotto_bet_limit_packages: "Lotto Bet Limit Packages",
  lottery_bet_limit_packages: "Lottery Bet Limit Packages",

  member_log: "Member Log",
  member_balance: "Member Balance",
  master_credit: "Master Credit",
  member_credit_limit: "Member Credit Limit",
  max_credit_limit: "Max Credit Limit",
  min_max_bet: "Min/Max Bet",
  min_bet: "Min Bet",
  max_bet: "Max Bet",
  max_per_match: "Max Per Match",
  mix_parlay: "Mix Parlay",
  mmo_parlay: "Myanmar Parlay",
  money_line: "Money Line",
  min: "Min",
  max: "Max",
  market_type: "Market Type",
  match_time: "Match Time",
  match_id: "Match ID",
  member_id: "Username",
  match: "Match",
  master_outstanding: "Master Outstanding",
  mode: "Mode",
  member_outstanding: "Member Outstanding",
  match_result: "Match Result",
  messages: "Messages",
  message: "Message",
  member_management: "Member Mgmt",
  member_bulk: "Member Bulk",
  manila_nocomm: "Manila Suite 0% Commission",
  match_status: "Match Status",

  new: "New",
  new_login_id: "New Login ID",
  new_username: "New Username",
  new_password: "New Password",
  new_security_code: "New Security Code",
  new_account: "New Account",
  next: "Next",
  no_goal: "No Goal",
  "no/": "No.",
  normal: "Normal",
  normal_announcements: "Normal Announcements",

  on: "ON",
  off: "OFF",
  ok: "OK",
  over: "Over",
  overview: "Overview",
  old_password: "Old Password",
  outstanding: "Outstanding",
  outstanding_balance: "Outstanding Balance",
  over_under: "Over/Under",
  odd_even: "Odd/Even",
  ou: "OU",
  oe: "OE",
  others: "Others",
  correct_score: "Correct Score",
  odd: "Odd",
  oxt: "1X2",
  outright: "Outright",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",
  odds_display: "Odds Display",
  online_player: "Online Player",
  opening_balance: "Opening Balance",
  oxtoeml: "@:ui.oe/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "3 Ways Handicap",
  others_sports: "Other Sports",
  opkey: "OP Key",
  operator_limit: "Operator Limit",
  operator: "Operator",
  one_winner: "1 Winner",

  pending: "Pending",
  platform: "Platform",
  pt: "Position Taking",
  password: "Password",
  profile_id: "Profile ID",
  parent_id: "Parent ID",
  page_size: "Page size",
  profile: "Profile",
  payment_option: "Payment Option",
  part_one: "Part One",
  part_two: "Part Two",
  position_taking: "Position Taking",
  preview_settings: "Preview Settings",
  preview: "Preview",
  parlay: "Parlay",
  parlaymmo: "Parlay MMO",
  position_taking_log: "Position Taking Log",
  platform_code: "Platform Code",
  platform_name: "Platform Name",
  pay: "Pay | Pay All",
  payout: "Payout",
  product: "Product",
  pending_matches: "Pending Matches",
  pt_share: "Position Shares",
  platform_settings: "Platform Settings",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  personal: "Personal",
  personal_message: "Personal Message",
  password_reset: "Password Reset",
  password_update: "Password Update",
  public: "Public",
  private: "Private",
  public_free: "Public (Free)",
  players_joined: "Players Joined",
  pool: "Pool",
  players: "Players",
  pay_type: "Pay Type",
  plus: "Plus",

  refresh: "Refresh",
  reset: "Reset",
  remaining_credit: "Remaining Credit",
  remaining: "Remaining",
  rate: "Rate",
  report: "Report",
  running: "Running",
  remark: "Remark",
  refund: "Refund",
  range: "Range",
  reject: "Reject",
  reset_accumulate_win: "Reset Accumulated Win",
  room_type: "Room Type",
  room_status: "Room Status",
  room_id: "Room ID",
  room_host: "Room Host",
  reason: "Reason",
  room_match: "Room Match",

  status: "Status",
  succeed: "Succeed",
  submit: "Submit",
  settings: "Settings",
  save: "Save",
  search: "Search",
  suspend: "Suspend",
  security_tag: "Security Tag",
  sub_account: "Sub Account",
  search_and_copy: "Search And Copy",
  search_existing: "Search Existing",
  skip: "Skip",
  settings_limit: "Settings Limit",
  sportsbook: "Sportsbook",
  slot_games: "Slot Games",
  soccer: "Soccer",
  sport_types: "Sport Types",
  settlement: "Settlement",
  submatch_id: "Sub-match ID",
  score: "Score",
  submatch_code: "Sub-match Code",
  settlement_list: "Settlement List",
  sub_total: "Sub Total",
  settle_amount: "Settlement Amount",
  settlement_history: "Settlement History",
  settlement_member: "Member Settlement Details",
  sport_type: "Sport Type",
  slot_platform: "Slots Platform",
  simple_report: "Simple Report",
  status_update: "Update Status",
  set_authority: "Set Authority",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "Slots",
  security_update: "Update Security",
  security_code: "Security Code",
  success: "Success",
  stock: "Stock",
  special: "Special",
  special_announcements: "Special Announcements",
  seconds: "Seconds",
  security_disable: "Security Disabled",
  select_all: "Select All",
  start_time: "Start Time",
  sport: "Sport",

  schedule_1: "Monday | Mon",
  schedule_2: "Tuesday | Tue",
  schedule_3: "Wednesday | Wed",
  schedule_4: "Thursday | Thu",
  schedule_5: "Friday | Fri",
  schedule_6: "Saturday | Sat",
  schedule_7: "Sunday | Sun",

  twtn: "To Win To Nil",
  total_outstanding: "Total Outstanding",
  target_id: "Target ID",
  target_action: "Target Action",
  total: "Total",
  types: "Types",
  total_goal: "Total Goal",
  tennis: "Tennis",
  today: "Today",
  thisweek: "This Week",
  thismonth: "This Month",
  transaction_log: "Transactions Log",
  total_bet: "Total Bet",
  transaction_date: "Transaction Date/Time",
  transfer_method: "Transfer Method",
  turnover: "Turnover",
  total_balance: "Total Balance",
  total_tran: "Total Transaction",
  total_base: "Total Member Bet",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "Top 10 Winner of the month",
  top_turnover: "Top 10 Highest Turnover of the month",
  type: "Type",
  total_downline: "Total Downline",
  to: "To",
  transfer: "Transfer",
  transfer_list: "Transfer List",
  transfer_history: "Transfer History",
  this_month: "This Month",
  this_week: "This Week",
  total_league: "Total League",
  total_match: "Total Match",
  three_winner: "3 Winner",

  under: "Under",
  upline_id: "Upline ID",
  unblock: "Unblock",
  update: "Update",
  username: "Username",
  update_commission_sb: "Commission Sportsbook",
  update_commission_lc: "Commission Livecasino",
  update_commission_sl: "Commission Slots",
  update_commission_lo: "Commission Lotto",
  update_commission_kn: "Commission Keno",
  update_commission_cf: "Commission Cockfight",
  update_commission_lt: "Commission Lottery",
  update_bet_limit_lc: "Bet Limit Livecasino",
  update_bet_limit_sb: "Bet Limit Sportsbook",
  update_bet_limit_lo: "Bet Limit Lotto",
  update_bet_limit_kn: "Bet Limit Keno",
  update_bet_limit_cf: "Bet Limit Cockfight",
  update_bet_limit_lt: "Bet Limit Lottery",
  update_position_sb: "Position Taking Sportsbook",
  update_position_lc: "Position Taking Livecasino",
  update_position_sl: "Position Taking Slots",
  update_position_lo: "Position Taking Lotto",
  update_position_kn: "Position Taking Keno",
  update_position_cf: "Position Taking Cockfight",
  update_position_lt: "Position Taking Lottery",
  update_account: "Update Account",
  update_platform: "Update Platform",
  upline_pt: "Upline PT",
  upline_remaining: "Upline Remaining",
  unblock_profile: "Profile Unblock",
  unselect_all: "Un-select All",

  view_details: "View Details",
  view_downline: "View Downline",
  value: "Value",
  valid_turnover: "Valid Turnover",
  void: "Void",

  winlose_limit: "Win Lose Limit",
  wallet: "Wallet",
  winlose: "Win Lose",
  win_limit: "Win Limit",
  win_limit_multiplier: "Win Limit Multiplier",
  win_limit_tooltips: "Only applicable for Livecasino.",
  win_limit_tooltips1: "Due to Casino API latency, players may be able to continue betting for a few minutes after reaching Win Limit. ",
  win_limit_0: "Unlimited",
  win_limit_1: "Credit Limit x 1",
  win_limit_2: "Credit Limit x 2",
  win_limit_5: "Credit Limit x 5",
  win_limit_10: "Credit Limit x 10",
  win_limit_20: "Credit Limit x 20",
  winlose_column1: "W/L",
  winlose_column2: "Comm",
  winlose_today: "Win Lose Today",
  winlose_yesterday: "Win Lose Yesterday",
  winner: "Winner",
  won: "Won",
  win_half: "Win Half",
  working_date: "Working Date",

  yesterday: "Yesterday",
  yesterday_balance: "Yesterday Balance",

  provider_evo: "Evolution Gaming",
  provider_gp: "Manila suite",
  provider_vivo: "Vegas suite",
  provider_sa: "Bangkok suite",
  provider_ct: "Hanoi suite",
  provider_slots: "Slots",
  provider_lotto: "Lotto",
  provider_keno: "Keno",
  provider_cockfight: "Cockfight",
  provider_lottery: "Lottery",

  suffix: "Suffix",
  callback_url: "Callback URL",
  email: "Email",
  seamless: "Seamless",
  key: "Key",
  inactive: "Inactive",

  ip_settings: "IP Settings",
  updated_on: "Updated On",
  updated_by: "Updated By",
  add_ip: "Add IP",
  ip: "IP",
  whitelisted_ip: "Whitelisted IP",
  cash_deposit: "Cash Deposit",
  cash_withdrawal: "Cash Withdrawal",
  fail: "Failed",
  max_amt: "Max Amount",

  timer: "Timer",
  no_refresh: "No refresh",
  actual_yesterday_balance: "Actual Yesterday Balance",

  bet_limit_default: "Bet Limit Default",
  bet_limit_single: "Bet Limit Single",
  hdp_package: "HDP Package",
  update_hdp_package: "Update HDP Package",
  update_bet_limit_default: "Update Bet Limit Default",
  update_bet_limit_single: "Update Bet Limit Single",

  refno: "Ref No.",
  system_parlay: "System Parlay",
  total_accepted: "Total Accepted",
  total_rejected: "Total Rejected",
  total_stake: "Total Stake",
  total_winlose: "Total Win/Lose",
  fold: "Fold",
  combination: "Combination",

  running_score: "Running Score",
  abandoned: "Abandoned",
  tournament: "Tournament",
  tournament_match: "Tournament Match",
  tournament_refund_list: "Tournament Refund List",
  room_1: "Public",
  room_2: "Private",
  room_3: "Public (Free)",
  op_tournament: "OP Tournament",
  adjustment: "Adjustment",

  cashout: "Cash Out",
  
  password_rules: "Password rules",
  password_rules_intro: "Password must meet the following rules:",
  security_code_rules: "Security code rules",
  security_code_rules_intro: "Security code must meet the following rules:",

  // OTP 2FA Translations
  setup_otp_via_mobile_authenticator: "Set up OTP via Mobile Authenticator",
  step_1_download_google_authenticator: "1. Download Google Authenticator on your device.",
  step_2_create_account_scan_qr: "2. Create an account by scanning this QR code with Google Authenticator.",
  step_3_enter_6_digit_code_verify: "3. Enter the 6-digits code generated by Google Authenticator into the textbox below and then click Verify to complete the registration.",
  download_on_app_store: "Download on the App Store",
  get_it_on_google_play: "Get it on Google play",
  regenerate_qr: "Regenerate QR",
  unable_to_scan_qr_code: "Unable to scan the QR code?",
  manual_entry_secret: "Manual entry secret",
  otp: "OTP",
  verify: "Verify",
  enable_otp_via_mobile_authenticator_app: "Enable OTP via Mobile Authenticator App",
  two_factor_authenticator_bound: "Two-factor authenticator bound",
  unbind: "Unbind",
  setup_2fa: "Setup 2FA",
  enter_6_digit_code: "Enter 6-digit code",
  verification_code: "Verification Code",

};